export default __webpack_public_path__ + "static/media/terminal.e3cb8805.svg";